import React from 'react';

export default class  Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to influence others.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>How easily influenced are you?</p>


                                            <div className="border_subtitle">Use your influence</div>
                                            <p>Most of us would consider ourselves to be reasonably shrewd in
                                                decision-making, and not easily coerced into doing something
                                                against our will. Much of the research<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>1</sup></a> into
                                                obedience and authority has shown that we are susceptible to
                                                powerful influence from respected figures. This is clearly shown
                                                by the classic experiment (outlined below) by Stanley Milgram in
                                                the 1960s which has been successfully recreated in modern
                                                studies.<a className="superscripttext"
                                                           href="further_info.php?course=300"><sup>2</sup></a>
                                            </p>


                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">A shocking experiment<a
                                                    className="superscripttext boldlink"
                                                    href="further_info.php?course=300"><sup>3</sup></a></div>
                                                <p>Unwitting participants were brought into a laboratory setting
                                                    and told they were taking part in a study aimed to enhance
                                                    memory by using electric shocks as part of a learning task.
                                                    They were instructed to question a fellow participant (who
                                                    was behind a screen) and, upon an incorrect answer, to
                                                    deliver an electric shock. With each incorrect answer,
                                                    participants were told to increase the voltage – ranging
                                                    from ‘Slight Shock’ to ‘DANGER: XXX’. What the participant
                                                    didn’t know was that the person receiving the shocks was
                                                    actually an actor and the shocks delivered were not
                                                    real.</p>
                                                <div className="uiheading"><p>Most shocking of all was that the
                                                    participants, despite believing they were delivering the
                                                    shocks, continued to question the actor and deliver the
                                                    shocks. In total, 65% of participants went as far as
                                                    delivering the ‘XXX’ shocks when encouraged to do so, even
                                                    after the actor had complained of heart difficulty and had
                                                    stopped responding to the questions. The person overseeing
                                                    the experiment and issuing instructions was wearing a white
                                                    coat – a clear symbol of authority at that time.
                                                    Interestingly, in a replication of the study, the location
                                                    was changed and the scientist was dressed in civilian
                                                    clothing, without the white coat. These differences saw
                                                    obedience levels drop significantly, with only 48% of
                                                    participants willing to deliver the apparently lethal
                                                    shocks.</p></div>
                                            </div>

                                            <div className="right-btn"><div
                                                onClick={this.props.handleChangePage('Page2')}
                                                className="button-next-previous-done">Next &gt;&gt;</div></div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}